export const cnpjFormatter = (cnpj = ``) => {
  return `${cnpj}`
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
};

export const removeNullFromObject = (target) => {
  const keys = Object.keys(target);
  const result = {};
  keys.forEach((key) => {
    if (target[key]) {
      result[key] = target[key];
    }
  });
  return result;
};
